<template>
  <v-tooltip slot="append" top v-if="enableTooltip" v-model="showTooltip">
    <template v-slot:activator="{}">
      <div :class="wrapperClass">
        <span @click.prevent.stop="activateTooltip()">
          <v-icon :class="isActive ? 'active' : ''">
            {{ isActive ? 'mdi-information' : 'mdi-information-outline' }}
          </v-icon>
        </span>
      </div>
    </template>
    <div class="tooltip-text" v-if="showTooltip">
      <span v-html="tooltipTekstas"></span>
    </div>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ElTooltip',
  props: {
    tooltip: String,
    tooltipKey: { type: String, default: '' },
    absolute: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    sutikimas: { type: Boolean, default: false },
    autocomplete: { type: Boolean, default: false },
    external: { type: Boolean, default: false },
  },
  data() {
    return {
      // showTooltip: false,
    }
  },
  computed: {
    ...mapGetters(['infoTooltips', 'activeTooltip']),
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop'
      )
    },
    showEmpty() {
      return this.isLocal
    },
    enableTooltip() {
      return (
        (this.tooltipTekstas !== '' && this.tooltipItem.too_aktyvus === true) ||
        this.showEmpty
      )
    },
    tooltipItem() {
      return (
        this.infoTooltips.find(item => item.too_kodas === this.tooltip) ?? {}
      )
    },
    tooltipTekstas() {
      return this.tooltipItem.too_tekstas
        ? this.tooltipItem.too_tekstas
        : this.showEmpty
        ? this.tooltip
        : ''
    },
    wrapperClass() {
      if (this.sutikimas) {
        return 'tooltip-wrapper-sutikimas'
      }
      if (this.absolute) {
        return 'tooltip-wrapper-absolute'
      }
      if (this.autocomplete) {
        return 'tooltip-wrapper-autocomplete'
      }
      if (this.inline) {
        return 'tooltip-wrapper-inline'
      }
      return 'tooltip-wrapper-relative'
    },
    fullTooltip() {
      return this.tooltip + this.tooltipKey
    },
    isActive() {
      return this.fullTooltip === this.activeTooltip
    },
    showTooltip: {
      get() {
        return this.fullTooltip === this.activeTooltip && !this.external
      },
      set(elValue) {
        //
      },
    },
  },
  methods: {
    activateTooltip() {
      let active = this.isActive ? '' : this.fullTooltip
      this.$emit('activate', active)
      this.$store.dispatch('activeTooltip', active)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';

.tooltip-wrapper-sutikimas {
  position: relative;
  top: 25px;
  left: 5px;
  transform: translateX(-22px) translateY(-22px);
}
.tooltip-wrapper-absolute {
  position: absolute;
  top: 0;
  left: 100%;
  transform: translateX(-22px) translateY(-22px);
}
.tooltip-wrapper-autocomplete {
  position: absolute;
  top: 0;
  left: 100%;
  transform: translateX(-22px) translateY(-10px);
}
.tooltip-wrapper-inline {
  display: inline-flex;
  position: relative;
  top: -5px;
  left: 3px;
}
.tooltip-wrapper-relative {
  position: relative;
  top: -7px;
  left: 5px;
}
.v-icon {
  font-size: 120%;
  cursor: pointer;
  color: $defaultText;

  &.active {
    color: var(--v-primary-base);
  }
}
.tooltip-text {
  max-width: 400px;
}
</style>
